import HttpService from "./http.service";
import axios from 'axios'
import {API_URL} from "../environment";
const instance= axios.create({
  baseURL: API_URL
});
instance.defaults.timeout = 20000 * 10000;
class ReportService extends HttpService {
  
  serviceReportList = (params) => this.get("cons_report/list", params);
  labelServiceReportList = (params) => this.get("cons_report_data/list", params);
  contentReportList = (params) => this.get("cont_report/list", params);
  generateReport = (params) => this.post("common/upload-file", params);
  contentReport = (params) => instance.post("common/upload-file-con", params);
  reportLogs = (params) => instance.post("common/report-log", params);
}

export default new ReportService();
